type BlobLike = Blob | File

export interface Buff {
    byteLength: number
    slice(begin: number, end?: number): Promise<ArrayBuffer>
}

export const fileBuffer = (file: BlobLike) => ({
    slice: (begin: number, end?: number) => toArrayBuffer(file.slice(begin, end)),
    byteLength: file.size,
})

export const arrayBuffer = (buffer: ArrayBuffer) => ({
    slice: (begin: number, end?: number) => Promise.resolve(buffer.slice(begin, end)),
    byteLength: buffer.byteLength,
})

// A lot of things don't implement File.arrayBuffer so this is a polyfill
function toArrayBuffer(blob: BlobLike) {
    return new Promise<ArrayBuffer>((resolve) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(reader.result as ArrayBuffer)
        }
        reader.readAsArrayBuffer(blob)
    })
}
